import { render, staticRenderFns } from "./CircularLoading.vue?vue&type=template&id=49d8d11c&functional=true"
import script from "./CircularLoading.vue?vue&type=script&lang=js"
export * from "./CircularLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports